import * as React from "react";
import styles from "./About.module.css";

const About = () => {
  return (
    <>
      <div className={styles.aboutContainer}>
        <h1>Flavia Maria Nistor</h1>
        <div className={styles.aboutContentContainer}>
          <img src="./flavia.png" className={styles.aboutPhoto} width={1000}></img>
          <div className={styles.paragraphs}>
            <p>
              Flavia Nistor is a Romanian cultural and sculptural fashion designer based in London. Her research-led practice explores Eastern European heritage, flight and verticality through sculptural garments, installation and material experimentation.
            </p>

            <p>
              Prior to her MA, Flavia worked with NET-A-PORTER through a talent programme developed in partnership with The King's Foundation, co-developing a sustainability-led collection sold globally on NET-A-PORTER and featured in Vogue Business, Harper's Bazaar, Drapers and FashionUnited. During and after the programme, she met His Majesty King Charles III on two occasions.
            </p>

            <p>
              She later joined Tom Ford as Assistant Designer to the Head of Womenswear Leather, contributing to the development of the AW25 collection presented in Paris.
            </p>

            <p>
              Flavia completed an MA in Fashion at the Royal College of Art, where she developed The Shape of Flight, a sculptural fashion investigation into the relationship between body, garment and space. 
            </p>

            <p>
              During her MA, she also developed an original concept and led an interdisciplinary team in creating an immersive fragrance experience that won the International Flavors & Fragrances competition.
            </p>

            <p>
              Following her graduation from the Royal College of Art, Flavia continues to receive commissions from cultural institutions while pursuing her search for the shape of flight-translated through fashion and presented through new and unexpected formats.

            </p>
          
          </div>
        </div>
      </div>
      <div className={styles.mobileAboutContainer}>
        <h1>Flavia Maria Nistor</h1>
        <div className={styles.aboutContentContainer}>
          <img src="./flavia.png" className={styles.aboutPhoto}></img>
          <div className={styles.paragraphs}>
            <p>
              Flavia is a Romanian fashion designer based in London and
              Bucharest. During her studies at a prestigious UK Fashion
              University, she created bespoke outfits for clients in the music
              industry and worked to launch her own label - FlaviaNís.{" "}
            </p>
            <p>
              After graduation, she began to work for both small tailoring
              businesses and big retail companies like the YOOX NET-A-PORTER
              GROUP (YNAP). The undergoing project is designing and making a
              responsible luxury collection for YNAP in collaboration with THE
              KING'S FOUNDATION that will be launched and sold exclusively on
              NET-A-PORTER in late August 2024.{" "}
            </p>
            <p>
              Flavia's main focus is preserving the legacy of traditional
              craftsmanship, with an emphasis on traditional heritage through
              the lens of contemporary fashion. She is determined to make a
              positive impact on the luxury and fashion industry and believes
              that collaboration is key to resolving challenges throughout the
              supply chain.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
